"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var IconSelected_1 = __importDefault(require("./IconSelected"));

var styled_1 = require("./styled");

exports.ImageCircle = function (_a) {
  var image = _a.image,
      selected = _a.selected,
      activeBreakpoint = _a.activeBreakpoint,
      onPress = _a.onPress;
  var ContainerComponent = responsive_1.isSmall(activeBreakpoint) ? ImageCircleContainerSmall : ImageCircleContainerDefault;
  return react_1.default.createElement(react_native_1.TouchableWithoutFeedback, {
    onPress: onPress,
    disabled: selected,
    accessible: false
  }, react_1.default.createElement(ContainerComponent, null, react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ImageStyled, {
    source: {
      uri: image.source
    }
  }), selected && react_1.default.createElement(IconSelectedContainer, null, react_1.default.createElement(IconSelected_1.default, null)))));
};

var ImageCircleContainerSmall = styled_components_1.default(styled_1.ImageCircleBaseContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background-color: #e0dde7;\n    width: 70px;\n    height: 70px;\n    margin: 0 8px;\n"], ["\n    background-color: #e0dde7;\n    width: 70px;\n    height: 70px;\n    margin: 0 8px;\n"])));
var ImageCircleContainerDefault = styled_components_1.default(styled_1.ImageCircleBaseContainer)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: #e0dde7;\n    width: 84px;\n    height: 84px;\n    margin: 10px 8px;\n"], ["\n    background-color: #e0dde7;\n    width: 84px;\n    height: 84px;\n    margin: 10px 8px;\n"])));
var ImageStyled = styled_components_1.default(react_native_1.Image)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 50px;\n    height: 50px;\n"], ["\n    width: 50px;\n    height: 50px;\n"])));
var IconSelectedContainer = styled_components_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    right: 0;\n"], ["\n    position: absolute;\n    bottom: 0;\n    right: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;